enum publicRoots {
  'ChoiceModal' = 'choice-modal',
  'ConfirmModal' = 'confirm-modal',
  'ResumeModal' = 'resume-modal',
  'UpdateModal' = 'update-modal',
  'Loader' = 'loader',
}

export default publicRoots;
